module.exports = __webpack_public_path__ + "img/selbsterfahrung_320.248db047.png";